// auth.js

import Axios from "axios";
import { HOTELS_INFO, URLAPI } from "../configuration";
import { authTypes } from "../types/authTypes";
import { roles } from "./authRoles";
import { setHotelID } from "./hotelID";

export const Authenticate = (token, hotelID) => {
    console.log("Authenticate");
    return async (dispatch) => {
        dispatch(tokenLoading());

        if (!token) {
            const storedData = localStorage.getItem("user");
            if (storedData) {
                // If data is available in local storage, update the Redux store with it
                console.log(loadUserData(JSON.parse(storedData)));
                dispatch(loadUserData(JSON.parse(storedData)));

                return;
            }
        }

        if (!token) {
            return;
        }

        Axios({
            method: "post",
            url: `${URLAPI}/authenticate`,
            // `https://arosuitestaging.arosuite.com/api/Cuchulainn/Authenticate`,
            data: JSON.stringify({
                token: token,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                console.log({ response });
                const { data } = response;

                const user = {
                    user: data.email,
                    user_id: data.user_id,
                    photo: data.photo,
                    expiresOn: data.expires_on,
                    firstName: data.first_name,
                    lastName: data.last_name,
                    rolesHotels: [...data.roles_hotels].sort(
                        (a, b) => parseInt(a) - parseInt(b)
                    ),
                    roles: data.roles,
                    jwt: data.jwt,
                };

                dispatch(loadUserData(user));
                dispatch(roles(data.roles, user.rolesHotels));

                const normalizedHotelID =
                    hotelID === 0 || hotelID === "0"
                        ? "default"
                        : String(hotelID);

                if (normalizedHotelID !== null) {
                    // If we received a hotel to set by URL, keep the existing behavior
                    // (admin can set any existing hotel; non-admin only if it's in roles_hotels)
                    if (data.roles_hotels.includes(-1)) {
                        if (
                            Object.keys(HOTELS_INFO).includes(normalizedHotelID)
                        ) {
                            dispatch(setHotelID(normalizedHotelID));
                        } else {
                            console.log(
                                `No hotel with hotelID of ${normalizedHotelID}`
                            );
                        }
                    } else if (data.roles_hotels.includes(normalizedHotelID)) {
                        dispatch(setHotelID(normalizedHotelID));
                    } else {
                        // If the user cannot access that hotel, fall back to first allowed
                        dispatch(
                            setHotelID(
                                data.roles_hotels
                                    .sort((a, b) => parseInt(a) - parseInt(b))
                                    .filter((el) => el !== -1)[0]
                            )
                        );
                    }
                } else if (data.roles_hotels.includes(-1)) {
                    // Coming from login with NO ?hotelid= and user is admin/Aró => force "default"
                    dispatch(setHotelID("default"));
                } else if (
                    data.roles_hotels.filter((el) => el !== -1).length >= 1
                ) {
                    // Coming from login with NO ?hotelid= and user is non-admin => first allowed
                    dispatch(
                        setHotelID(
                            data.roles_hotels
                                .sort((a, b) => parseInt(a) - parseInt(b))
                                .filter((el) => el !== -1)[0]
                        )
                    );
                } else {
                    console.log("Not found hotelID", data, normalizedHotelID);
                }

                localStorage.setItem("user", JSON.stringify(user));
            })
            .catch((error) => {
                console.log({ error });
                alert(`Error: ${error.response.data.error.Message}`);
                window.location = "/";
            });
    };
};

export const loadUserData = (user) => {
    return {
        type: authTypes.token,
        payload: {
            user: user,
            loading: false,
        },
    };
};

export const tokenLoading = () => {
    return {
        type: authTypes.token,
        payload: {
            loading: true,
        },
    };
};
